<template>
  <div class="bg-white mg-40 rounded-20 pd-lg-20" style="background-color: rgb(226, 226, 226)">
    <div class="mg-b-20 pd-b-10 bd-b d-flex align-items-center">
      <router-link
        :to="{
          name: 'lmsLibrary',
          params: { id: 0, cid: 0, title: 'Номын сан', m: 0 },
        }"
      >
        <feather type="chevron-left" class="mg-r-10"></feather>
      </router-link>
      <h5 class="tx-semibold mg-b-0 tx-20" v-if="bkDtl.rdy">
          {{ bkDtl.obj.task }}
        </h5>

      <attach-rating
        v-if="fileInf.ready"
        :fileInf.sync="fileInf"
        class="mg-l-auto"
        disabled
        @on-rate="onRated"
        :allowHalf="false"
      />
      <button
        v-if="
          bkDtl.rdy && bkDtl.obj.isRepeat && bkDtl.obj.secondAttachmentUrl != ''
        "
        @click="downloadBook()"
        class="mg-l-10 btn btn-outline-success btn-xs"
      >
        <feather type="download" class="mg-r-5"></feather>
        татах
      </button>
    </div>
    <file-preview
      v-if="bkDtl.rdy"
      :id.sync="bkDtl.obj.defaultAttachmentId"
      @on-file-loaded="onFileLoaded"
      :force="true"
      :key="bkDtl.key"
      class="d-none"
    />

    <file-preview
      v-if="bkDtl.rdy"
      :id.sync="bkDtl.obj.secondAttachmentId"
      :params="$route.params"
      :force="true"
      :minusHeight="$store.state.app.isMobile ? 140 : 160"
    />
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
//import { Notification } from "element-ui";

export default {
  components: {
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      scrHeight: {
        execution: 300,
        executionReply: 600,
      },
      bkDtl: {
        key: 0,
        obj: {},
        rdy: false,
      },
      fileInf: {
        ready: false,
        obj: {},
      },
      order: {
        task: {},
        obj: {},
        info: "",
        coverId: null,
        attachId: null,
        tip: "",
        confirm: false,
        mdl: false,
        itemId: null,
      },
      fileDialog: {
        show: false,
        id: 0,
      },
    };
  },
  mounted() {
    this.init(this.$route.params.id);
  },
  methods: {
    onFileLoaded(e) {
      //console.log('onFileLoaded', e);
      this.fileInf = { obj: e, ready: true };
    },
    onRated(e) {
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },
    //# book execution
    executionInit(e) {
      this.$refs.executionList.initById(e);
    },
    init(id) {
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          // console.log(res);
          this.order.info = res.data.task.taskDesc;
          this.order.attachId = res.data.task.secondAttachmentId;
          this.order.task = res.data.task;
          this.bkDtl.obj = res.data.task;
          this.bkDtl.key = res.data.id;
          this.bkDtl.rdy = true;
          this.order.mdl = true;
        }
      });
    },
    downloadBook() {
      window.open(
        this.bkDtl.obj.secondAttachmentUrl +
          "?i=" +
          Math.floor(Math.random() * 100),
        "_blank"
      );
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
  },
};
</script>
